export default {
  login: "api/token/",
  loginwithotp: "api/login/otp/",
  VERIFYotp: "api/login/verify-otp/",
  forgot: "api/password-reset-request/",
  reset: "api/password_reset/confirm/",
  invite: (id) => `api/accept-invitation/${id}/`,
  newpassword: (token) => `api/password-reset/${token}/`,
};
